// Compatibility re-export (BKPE-27795). See `features/observability/logger/middleware/shared`.
export * from 'features/observability/logger/middleware/shared';
